import { repository, baseURL } from "@/api/base"

export default {
  async findAllCurators() {
    const { data } = await repository.get(baseURL + '/user/findAllCurators')
    return data
  },
}
